import axios from "axios";
import store from "../store";
import { navigateToLogin } from "../utils/navigate";
import { TOKEN_REFRESH_SUCCESS, TOKEN_REFRESH_FAIL } from "../actions/types";
import SecureStorage from "../utils/secureStorage";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3000/", // Default to localhost if not set
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
api.interceptors.request.use(
  async (config) => {
    let { token } = store.getState().auth;

    if (!token) {
      token = await SecureStorage.get("token");
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// XSS Security Headers
api.interceptors.request.use((config) => {
  config.headers["X-Frame-Options"] = "DENY";
  config.headers["X-Content-Type-Options"] = "nosniff";
  config.headers["X-XSS-Protection"] = "1; mode=block";
  return config;
});

// Handle token expiration and refresh
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        const state = store.getState();

        //const refreshToken = localStorage.getItem('refreshToken');
        let refreshToken = state.auth.refreshToken;

        if (!refreshToken) {
          refreshToken = await SecureStorage.get("refreshToken");
        }

        if (refreshToken) {
          //Refresh the token
          try {
            const res = await axios.post(
              "/api/auth/refresh",
              { refreshToken },
              {
                headers: {
                  Authorization: `Bearer ${state.auth.token}`,
                },
              }
            );

            if (res.status === 201) {
              await SecureStorage.set("token", res.data.token);
              await SecureStorage.set("refreshToken", res.data.refreshToken);

              api.defaults.headers.common["Authorization"] = "Bearer " + res.data.token;
              originalRequest.headers["Authorization"] = "Bearer " + res.data.token;

              store.dispatch({
                type: TOKEN_REFRESH_SUCCESS,
                payload: {
                  token: res.data.token,
                  refreshToken: res.data.refreshToken,
                },
              });
              return api(originalRequest);
            }
          } catch (refreshError) {
            console.log(refreshError);
            //Return error to state
            store.dispatch({
              type: TOKEN_REFRESH_FAIL,
            });

            //Redirect to login
            navigateToLogin();
          }
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
